<div class="modal-header">
  <h4 class="modal-title-bold">{{ title | translate }}</h4>
  <button (click)="close()" type="button" class="btn btn-link text-dark">
    <i class="fa-solid fa-times fa-fw fa-sm"></i>
  </button>
</div>
<div class="modal-body">
  <div
    *ngIf="!loading; else fileIsLoading"
    class="image content-height"
    [ngClass]="{ 'can-zoom': canZoom, zoomed: zoomed }"
  >
    <button
      *ngIf="!zoomed && files && files.length > 1"
      class="nav-btn prev"
      (click)="goPrev()"
    >
      <i class="fa-duotone fa-chevron-left fa-fw"></i>
    </button>
    <img
      *ngIf="fileBlob"
      [src]="fileBlob"
      [alt]="file.description"
      (click)="canZoom && toggleZoom()"
      (load)="onImageLoad($event)"
    />
    <button
      *ngIf="!zoomed && files && files.length > 1"
      class="nav-btn next"
      (click)="goNext()"
    >
      <i class="fa-duotone fa-chevron-right fa-fw"></i>
    </button>
  </div>
  <div *ngIf="files && files.length > 1" class="thumbnail-container">
    <div
      *ngFor="let fileOption of files"
      class="thumbnail-content"
      (click)="file = fileOption"
    >
      <img
        [src]="'data:image/jpeg;base64,' + fileOption.thumbnail"
        [alt]="fileOption.description"
      />
    </div>
  </div>
</div>
<div class="modal-footer">
  <div *ngIf="canRotate" class="btn-group" role="group">
    <button class="btn btn-secondary" (click)="rotate(true)">
      <i class="fa-regular fa-rotate-left fa-fw"></i>
    </button>
    <button class="btn btn-secondary" (click)="rotate()">
      <i class="fa-regular fa-rotate-right fa-fw"></i>
    </button>
  </div>
  <button
    *ngIf="!readonly && changePrivacyOption"
    (click)="updatePrivacy()"
    type="button"
    class="btn btn-secondary"
  >
    <ng-container *ngIf="file.isPrivate">
      <i class="fa-regular fa-lock"></i>
      {{ 'files.photoGalleryModal.makePublic' | translate }}
    </ng-container>
    <ng-container *ngIf="!file.isPrivate">
      <i class="fa-regular fa-lock-open"></i>
      {{ 'files.photoGalleryModal.makePrivate' | translate }}
    </ng-container>
  </button>
  <button class="btn btn-secondary" (click)="fileDownload()">
    <i class="fa-regular fa-download fa-fw"></i>
    {{ 'shared.terms.download' | translate }} ({{ file.size | fileSize }})
  </button>
  <button
    *ngIf="!readonly"
    class="btn btn-danger ml-auto"
    (click)="onDeleteClick()"
  >
    <i class="fa-solid fa-trash fa-fw"></i>
    {{ 'shared.terms.delete' | translate }}
  </button>
</div>

<ng-template #fileIsLoading>
  <sh-loading-indicator
    class="d-flex justify-content-center align-items-center content-height"
  ></sh-loading-indicator>
</ng-template>
